import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const createSubscription: ThemeApp['appComponents']['createSubscription'] = {
  subscriptionTypes: {
    pro: {
      components: {
        proFooter: {
          container: {
            backgroundColor: themeUi.semantic.color.background.secondary990
          },
          verticalLine: {
            backgroundColor: themeUi.semantic.color.border.secondary800
          },
          planPrice: {
            container: {
              color: themeUi.semantic.color.text.secondary50
            }
          }
        }
      },
      steps: {
        components: {
          reviewAndCreate: {
            components: {
              costsAndPayment: {
                costsAndPayment: {
                  hr: {
                    backgroundColor: themeUi.semantic.color.background.neutral500
                  },
                  explanationText: {
                    color: themeUi.semantic.color.text.neutral600
                  }
                },

                components: {
                  applyCoupon: {
                    couponContainer: {
                      backgroundColor: themeUi.semantic.color.background.secondary900,
                      dividerColor: themeUi.semantic.color.background.secondary800
                    },
                    couponTitle: {
                      color: themeUi.semantic.color.text.secondary50
                    }
                  },

                  blockTitle: {
                    hr: {
                      backgroundColor: themeUi.semantic.color.background.neutral500
                    }
                  },

                  totalSubPrice: {
                    darkBlueTextColor: {
                      color: themeUi.semantic.color.text.secondary50
                    },
                    perMonthText: {
                      color: themeUi.semantic.color.text.neutral600
                    }
                  }
                }
              },

              databasesTable: {
                wrappedTable: {
                  borderTop: themeUi.semantic.color.border.neutral300
                }
              },

              subscriptionProperties: {
                propertyRow: {
                  color: themeUi.semantic.color.text.neutral700
                }
              },

              vendorDetailsAndName: {
                leftSection: {
                  backgroundColor: themeUi.semantic.color.background.secondary800
                },
                inputInnerContainer: {
                  backgroundColor: themeUi.semantic.color.background.secondary800
                },
                sharedLabelsStyle: {
                  color: themeUi.semantic.color.text.neutral700
                },
                valueText: {
                  color: themeUi.semantic.color.text.secondary50
                }
              }
            }
          },

          setup: {
            components: {
              advancedOptions: {
                components: {
                  availabilityZone: {
                    labelText: {
                      color: themeUi.semantic.color.text.secondary50
                    }
                  },

                  cloudAccountSelect: {
                    title: {
                      color: themeUi.semantic.color.text.secondary50
                    }
                  },

                  autoTiering: {
                    title: {
                      color: themeUi.semantic.color.text.secondary50
                    },
                    description: {
                      color: themeUi.semantic.color.text.neutral400
                    }
                  },

                  multiAz: {
                    title: {
                      color: themeUi.semantic.color.text.secondary50
                    },
                    description: {
                      color: themeUi.semantic.color.text.neutral400
                    }
                  },

                  vpcConfiguration: {
                    title: {
                      color: themeUi.semantic.color.text.secondary50
                    },
                    sectionHeader: {
                      color: themeUi.semantic.color.text.neutral400
                    }
                  },

                  resourceTags: {
                    tableContainer: {
                      borderColor: themeUi.semantic.color.border.neutral400
                    },
                    tableHeaders: {
                      borderBottom: themeUi.semantic.color.border.neutral400
                    },
                    separator: {
                      background: themeUi.semantic.color.border.neutral400
                    }
                  }
                }
              },

              multiSelectRegions: {
                regionDisplayField: {
                  color: themeUi.semantic.color.text.primary600
                }
              }
            }
          },

          sizing: {
            sizing: {
              wrappedTable: {
                borderTop: themeUi.semantic.color.border.neutral300
              }
            },

            components: {
              newDatabaseForm: {
                newDatabaseForm: {
                  divider: {
                    backgroundColor: themeUi.semantic.color.background.secondary800
                  }
                },

                components: {
                  optimizeProModal: {
                    components: {
                      optimizeRecommendations: {
                        text: {
                          color: themeUi.semantic.color.text.neutral600
                        }
                      }
                    },
                    optimizedValuesTitle: {
                      color: themeUi.semantic.color.text.secondary50
                    }
                  },

                  aaForm: {
                    hrDark: {
                      borderTop: themeUi.semantic.color.border.secondary800
                    }
                  },

                  advancedCapabilities: {
                    headerNoticeMessage: {
                      color: themeUi.semantic.color.text.neutral600,
                      fontSize: themeUi.core.font.fontSize.s12
                    },
                    recommendedText: {
                      color: themeUi.semantic.color.text.neutral700,
                      fontSize: themeUi.core.font.fontSize.s14
                    },
                    advancedCapabilitiesTitle: {
                      color: themeUi.semantic.color.text.secondary50,
                      fontSize: themeUi.core.font.fontSize.s16
                    }
                  },
                  midSection: {
                    hashingPolicy: {
                      hashingPolicyConfiguration: {
                        tooltip: {
                          color: themeUi.semantic.color.text.secondary50
                        }
                      },
                      components: {
                        hashingPolicySelection: {
                          popover: {
                            color: themeUi.semantic.color.text.secondary50
                          }
                        }
                      }
                    }
                  },

                  moreOptions: {
                    verticalDivider: {
                      backgroundColor: themeUi.semantic.color.background.secondary800
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  },

  components: {
    cloudAndRegionSelection: {
      components: {
        creationRegionSelect: {
          creationRegionSelect: {
            title: {
              color: themeUi.semantic.color.text.neutral700
            },
            selectContentBottom: {
              borderTop: themeUi.semantic.color.border.secondary800
            }
          },

          components: {
            newRedisOptInToggle: {
              text: {
                enabledColor: themeUi.semantic.color.text.neutral700,
                disabledColor: themeUi.semantic.color.text.neutral500
              }
            },

            renderRegionItem: {
              optInText: {
                color: themeUi.semantic.color.text.neutral600
              }
            }
          }
        }
      }
    },
    formActionButtons: {
      container: {
        borderTop: `1px solid ${themeUi.semantic.color.border.secondary800}`
      }
    }
  }
};
